var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyListPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.375,
    height: 73.884,
    viewBox: "0 0 106.375 73.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_153745",
    "data-name": "Group 153745",
    transform: "translate(-656.5 -309.292)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1055",
    "data-name": "Ellipse 1055",
    cx: 53.188,
    cy: 15.252,
    rx: 53.188,
    ry: 15.252,
    transform: "translate(656.5 352.416)",
    fill: "#397ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299933",
    "data-name": "Path 299933",
    d: "M53.691-3.5c29.249,0,53.518,5.638,50.566,10.885S83.813,17.613,53.691,18.792,6.678,11.924,2.546,7.481,24.442-3.5,53.691-3.5Z",
    transform: "translate(655.921 364.129)",
    fill: "#0b4cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299934",
    "data-name": "Path 299934",
    d: "M0,.322,32.336-10.257V59.857L0,59.211Z",
    transform: "translate(681.138 319.549)",
    fill: "#417de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299935",
    "data-name": "Path 299935",
    d: "M-.415,0H55.031L53.147,61.211s-3.647.594-9.328,1.031c-4.853.374-11.514.584-18.144.828a139.835,139.835,0,0,1-27.4-2.105Z",
    transform: "translate(681.514 320.041)",
    fill: "#bad4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299936",
    "data-name": "Path 299936",
    d: "M-24034.535,11590.021s10.393,1.172,20.311,1.172a178.792,178.792,0,0,0,19.363-1.172",
    transform: "translate(24723.076 -11253.565)",
    fill: "none",
    stroke: "#397ef5",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299937",
    "data-name": "Path 299937",
    d: "M-24034.535,11590.021a156.892,156.892,0,0,0,17.559,1.172,133.963,133.963,0,0,0,16.738-1.172",
    transform: "translate(24723.076 -11244.18)",
    fill: "none",
    stroke: "#397ef5",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299938",
    "data-name": "Path 299938",
    d: "M-24034.535,11590.021a110.27,110.27,0,0,0,14.693,1.172,94.222,94.222,0,0,0,14.008-1.172",
    transform: "translate(24723.076 -11234.794)",
    fill: "none",
    stroke: "#9bc0ff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299939",
    "data-name": "Path 299939",
    d: "M-24034.535,11590.021a156.892,156.892,0,0,0,17.559,1.172,133.963,133.963,0,0,0,16.738-1.172",
    transform: "translate(24723.076 -11225.407)",
    fill: "none",
    stroke: "#9bc0ff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyListPlaceholder);
export default __webpack_public_path__ + "static/media/empty-list-placeholder.6752e90bdee554bae6231fbe067c2b52.svg";
export { ForwardRef as ReactComponent };